import React from "react";
import Loadable from "react-loadable";

import {AsyncLoadingIndicator} from "../../components/elementar";
import withUser from '../../components/tools/withUser/withUser';


const LoadableComponent = Loadable({
  loader: () => import("./ProfilerPage"),
  loading: AsyncLoadingIndicator
});

class ProfilerPageAsync extends React.Component {
  public render() {
    return <LoadableComponent/>;
  }
}

export default withUser(ProfilerPageAsync)